import React from 'react';
import { Box } from '@mui/material';
import ScreenerManager from './ScreenerManager';

interface ScreenersProps {
  profileId: string;
  profile: {
    id: string;
    name: string;
    investment_profile_template: string;
  };
}

const Screeners: React.FC<ScreenersProps> = ({ profileId, profile}) => {
  return (
    <Box p={3}>
      <ScreenerManager
        profileId={profileId}
        profile={profile}
      />
    </Box>
  );
};

export default Screeners; 